import { Tooltip } from '@mui/material';
import { DishComponent } from '../apiTypes';
import { t } from '../constants/translations';
import { useAdmin } from '../contexts/admin.context';
import { useCafe } from '../contexts/cafe.context';
import { useLocale } from '../contexts/locale.context';
import currency from '../utils/currency';
import { getComponentCost } from '../utils/getPriceByUnit';
import Image from './Image';

type Props = {
  component: DishComponent;
};

const DishComponentPreview = ({ component }: Props) => {
  const { lang } = useLocale();
  const { ingredientsMap, productsMap, semiProductsMap } = useCafe();
  const { cafe } = useAdmin();

  return (
    <Tooltip
      key={component.id}
      title={`${ingredientsMap[component.id]?.name}: ${component.qnt}${
        t[ingredientsMap[component.id]?.unit || 'pc'][lang]
      } (${currency(getComponentCost(component, productsMap, semiProductsMap), cafe?.currency, true)})`}
    >
      <div>
        <Image src={ingredientsMap[component.id]?.imageUrl} />
      </div>
    </Tooltip>
  );
};

export default DishComponentPreview;
